<template>
	<div class="ai_modal_container">
		<Header :title="title" :onClose="handleClose" />
		<div :class="`ai_modal_content_wrapper modal_content_padding`">
			<div v-if="content" v-html="formattedContent"></div>
			<slot v-else></slot>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import Header from '@/components/ai/AiHeader.vue'

export default {
	name: 'AiTerm2',
	data() {
		return {

		}
	},
	props: {
		title: {
			type: String,
			required: false
		},
		content: {
			type: String,
			required: false
		},
		onClose: {
			type: Function
		},
		hasPadding: {
			type: Boolean
		}
	},
	components: {
		Header
	},
	mounted(){
		this.getTermsFooterList();
	},
	computed: {
		formattedContent() {
			return this.content.replace(/\n/g, '<br>');
		}
	},
	methods: {

		async getTermsFooterList() {
			var $this = this;
			Vue.httpClient
				.post('/m/ai/term/list/footer', {})
				.then(response => {
					if (response.data.status == '200') {
						var result = response.data.result
						result.map((item) => {
							if (item.termType === 60) {
								$this.title = item.title
								$this.content = item.contents
							}
						})
					}
				})
		},

		handleClose() {
			this.$router.push({ name: 'AiMain' })
		},
	}
}
</script>

<style scope>
.ai_modal_container {
	position: fixed;
	top: 0;
	width: 100%;
	max-width: 768px;
	height: 100dvh;
	margin: 0 auto;
	z-index: var(--zIndex-modal);
	background-color: var(--gray-scale-12);
	overflow: auto;
}

.modal_content_padding {
	padding: 20px
}
</style>



// WEBPACK FOOTER //
// src/views/ai/term/AiTerm2.vue